// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';

import * as faqsActions from '../store/actions';
import { getData } from '../store/selectors';
import { Faq, SearchBar } from '../components';
import Navigation from '../../../common/Navigation/Navigation';
import styles from './styles';

class FaqsPage extends React.Component {
  state = {
    questions: [],
    gotData: false,
  };

  componentDidMount() {
    this.props.requestPageData();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.gotData && nextProps.data.questions.length > 0) {
      return {
        questions: nextProps.data.questions,
        gotData: true,
      };
    }
    return null;
  }

  render() {
    const { classes, data } = this.props;

    return (
      <Navigation mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <div className={classes.subMainContainer}>
            <h4 className={classes.title}>{data.title}</h4>
            <SearchBar
              onSearch={filteredQuestions => this.setState({ questions: filteredQuestions })}
              questions={data.questions}
            />
            <div className={classes.faqsContainer}>
              {this.state.questions.map(el => (
                <Faq key={uuidv4()} {...el} />))}
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

FaqsPage.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  requestPageData: PropTypes.func,
};

FaqsPage.defaultProps = {
  classes: {},
  data: {
    questions: [],
  },
  requestPageData: () => { },
};

const mapStateToProps = (state) => {
  return {
    data: getData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestPageData: () => dispatch(faqsActions.requestPageData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(FaqsPage));
